<template>
  <!-- video_area_start -->
  
  <div class="video_area">
    <div class="container-fluid p-0">
      <div class="row align-items-center no-gutters">
        <div class="col-xl-6 col-lg-6">
          <div class="video_info">
            <div data-aos="fade-right" class="about_info">
              <div class="section_title mb-20px">
                <span>{{ $t("video.subtitle") }}</span>
                <h3 v-html="$t('video.title')"></h3>
              </div>
              <p v-html="$t('video.text')"></p>
              <a href="#" class="boxed-btn3">{{ $t("video.book") }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6">
          <div class="video_thumb">
            <div class="video_thumb_inner">
              <img src="../../img/gallery/video.png" alt="Barbershop Agadir | salon de coiffure Agadir | صالون حلاقة" />
              <a
                href="https://www.instagram.com/v.i.p_agadir/"
                class="popup-video"
                target="blank"
              >
                <i class="fa fa-play"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
  <!-- video_area_end -->
</template>
<script>
export default {};
</script>


<style lang="scss" scoped>
@import "../../styles/_responsive.scss";
@import "../../styles/_mixins.scss";
@import "../../styles/_varriable.scss";
@import "../../styles/_reset.scss";
@import "../../styles/_bradcam.scss";
@import "../../styles/_btn.scss";
@import "../../styles/_section_title.scss";
@import "../../styles/font/flaticon.css";
@import "../../styles/font/font-awesome.min.css";
@import "../../styles/pages/_gallery.scss";


</style>